import React from 'react'
import Header from "../Components/Header/Header"
import AllPosts from '../Components/ViewMoreAllPosts/AllPosts'

function ViewMore() {
    return (
        <div>
         <Header/>
         <AllPosts/>        
        </div>
    )
}

export default ViewMore
